import { useState, useEffect } from "react";
import { wabaApi } from "../../lib/wabaApi";

// Mesmo app; configuração de Login for Business só com ads_read +
// business_management (contas de anúncio como ativo). Separada das outras
// pra não enfiar "ler seus anúncios" no diálogo de quem só quer WhatsApp.
const META_APP_ID = "843063592187222";
const ADS_CONFIG_ID = "4522044031398048";

interface Props {
  connectionId: string;
  onSuccess: () => void;
}

function errorText(err: any): string {
  const d = err?.payload?.detail;
  if (typeof d === "string") return d;
  if (d && typeof d === "object") return d.meta_message || d.error || JSON.stringify(d);
  return "Erro ao vincular os anúncios.";
}

export function AdsSignup({ connectionId, onSuccess }: Props) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (document.getElementById("fb-jssdk")) return;
    window.fbAsyncInit = () => {
      window.FB.init({ appId: META_APP_ID, autoLogAppEvents: true, xfbml: true, version: "v25.0" });
    };
    const script = document.createElement("script");
    script.id = "fb-jssdk";
    script.src = "https://connect.facebook.net/en_US/sdk.js";
    script.async = true; script.defer = true;
    document.body.appendChild(script);
  }, []);

  async function doLink(code: string) {
    try {
      await wabaApi.post(`/connections/${connectionId}/link-ads`, { code });
      onSuccess();
    } catch (err: any) {
      setError(errorText(err));
    } finally { setLoading(false); }
  }

  function handleSignup() {
    if (!window.FB) { setError("SDK da Meta ainda não carregou. Aguarde e tente novamente."); return; }
    setError(null); setLoading(true);
    // Callback síncrono: o SDK recusa async function (mesmo padrão dos outros signups).
    window.FB.login((response: any) => {
      const code = response?.authResponse?.code;
      if (!code) {
        setError("Cadastro cancelado ou código não retornado pela Meta.");
        setLoading(false); return;
      }
      doLink(code);
    }, {
      config_id: ADS_CONFIG_ID,
      response_type: "code",
      override_default_response_type: true,
    });
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      <button
        onClick={handleSignup}
        disabled={loading}
        style={{
          display: "flex", alignItems: "center", gap: 8,
          padding: "9px 18px",
          background: loading ? "var(--surface-input)" : "#1877F2",
          color: loading ? "var(--ink-muted)" : "#fff", border: "none", borderRadius: 8,
          fontSize: 13, fontWeight: 600, cursor: loading ? "default" : "pointer",
        }}
      >
        {loading ? "Conectando..." : "Conectar anúncios"}
      </button>
      {error && <span style={{ fontSize: 12, color: "var(--danger)" }}>{error}</span>}
    </div>
  );
}
